﻿import { useState, useCallback } from 'react';
import { api } from '@/services/api';
import { config } from '@/config/env';

export interface Customer {
  codcliente: string;
  ragsociale: string;
  tipologia?: string;
  [key: string]: unknown;
}

export function useCustomers() {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchCustomers = useCallback(async (codazienda: string, tipologia?: string) => {
    if (!codazienda || codazienda === '0') { setCustomers([]); return; }
    setLoading(true);
    try {
      const body: Record<string, string> = { camporicerca: '' };
      if (tipologia) body.tipologia = tipologia;

      const data = await api.post<Customer[]>(
        'clienti/ricerca-clienti-azienda/select/' + config.SITE + '/' + codazienda + '/' + config.NOME_APP,
        body
      );
      setCustomers(data || []);
    } catch {
      setCustomers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return { customers, loading, fetchCustomers };
}
